import { ApplicationRef, Inject, Injectable } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import {
  AlertAction,
  AlertComponent,
  AlertDialogData,
  RgpdDialogData,
} from './alert/alert.component';
import { Overlay, PositionStrategy } from '@angular/cdk/overlay';
import { WINDOW } from '@ng-web-apis/common';
import { IcilaluneDialogModule } from './icilalune-dialog.module';
import { RgpdPromptComponent } from '@nx-icilalune/rgpd';

@Injectable({
  providedIn: IcilaluneDialogModule,
})
export class DialogService {
  constructor(
    private dialog: Dialog,
    private overlay: Overlay,
    private applicationRef: ApplicationRef,
    @Inject(WINDOW) private window: Window
  ) {}

  openNotification(
    alertDialogData: AlertDialogData,
    disableClose = true
  ): DialogRef<AlertAction, AlertComponent> | undefined {
    let positionStrategy: PositionStrategy | undefined;

    if (this.window.innerWidth > 600) {
      positionStrategy = this.overlay
        .position()
        .global()
        .top('60px')
        .right('60px');
    }

    if (!this.dialog.getDialogById('notification')) {
      const dialogRef = this.dialog.open<
        AlertAction,
        AlertDialogData,
        AlertComponent
      >(AlertComponent, {
        id: 'notification',
        maxWidth: '100vw',
        positionStrategy,
        disableClose,
        backdropClass: 'alert-backdrop',
        panelClass: 'notification',
        data: alertDialogData,
      });
      this.applicationRef.tick();
      return dialogRef;
    }
    return undefined;
  }

  openAlert(
    alertDialogData: AlertDialogData,
    disableClose = true
  ): DialogRef<AlertAction, AlertComponent> | undefined {
    if (!this.dialog.getDialogById('alert')) {
      const dialogRef = this.dialog.open<
        AlertAction,
        AlertDialogData,
        AlertComponent
      >(AlertComponent, {
        id: 'alert',
        maxWidth: '100vw',
        disableClose,
        backdropClass: 'alert-backdrop',
        panelClass: 'alert',
        data: alertDialogData,
      });
      this.applicationRef.tick();
      return dialogRef;
    }
    return undefined;
  }

  openCookiesAlert(
    alertDialogData: RgpdDialogData,
    disableClose = true
  ): DialogRef<AlertAction, RgpdPromptComponent> | undefined {
    if (!this.dialog.getDialogById('cookiesAlert')) {
      const dialogRef = this.dialog.open<
        AlertAction,
        RgpdDialogData,
        RgpdPromptComponent
      >(RgpdPromptComponent, {
        id: 'cookiesAlert',
        width: 'clamp(320px, 460px, 90vw)',
        disableClose,
        backdropClass: 'cookies-alert-backdrop',
        panelClass: 'alert',

        data: alertDialogData,
      });
      this.applicationRef.tick();
      return dialogRef;
    }
    return undefined;
  }
}
